// Vuex project module actions

import { API } from '@/config';

import { FILL_LIST } from './mutations-types';

export default {

  async getAgentsBelongsToClientList({ commit }) {
    try {
      const { records, total } = (await API.get('/client/agent/getList')).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },

};
